// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content-wrapper {
  background: var(--ion-color-light);
  padding: 10px 6px 6px 6px;
  display: flex;
  flex-flow: column nowrap;
}

.window-header {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  padding-left: 10px;
  padding-bottom: 4px;
  margin-bottom: 16px;
  border-bottom: 1px solid var(--ion-color-medium);
}
.window-header .window-title {
  display: flex;
  align-items: center;
  color: var(--ion-color-dark);
}
.window-header .window-title ion-label {
  padding-left: 6px;
  font-size: 16px;
  font-weight: 500;
  cursor: default;
}

.page-detail {
  font-style: italic;
  color: var(--ion-color-primary-tint);
  white-space: pre-line;
  font-size: 0.9rem;
  padding-left: 6px;
}

.log-content {
  height: 70px;
  --background: var(--ion-color-light);
}
.log-content ion-list {
  background: var(--ion-color-light);
  padding-bottom: 0px;
}
.log-content ion-item {
  --background: var(--ion-color-light);
  --min-height: 28px;
  --inner-padding-end: 0px;
}
.log-content .log-date {
  width: 150px;
}

.ocr-params-header {
  background: var(--ion-color-light-shade);
  cursor: pointer;
}

.ocr-params-body {
  border: 1px solid var(--ion-color-light-shade);
  overflow: hidden;
  height: 100px;
}

.popover {
  --padding-top: 6px;
  --padding-bottom: 6px;
}

.popover-description {
  color: var(--ion-color-primary-tint);
  font-style: italic;
}

ion-select {
  min-height: 42px;
  --highlight-color-focused: var(--ion-color-primary);
  --highlight-color-invalid: var(--ion-color-primary);
  --highlight-color-valid: var(--ion-color-primary);
  --ripple-color: var(--ion-color-primary);
}

.buttons {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-end;
}
.buttons ion-button {
  min-height: 32px;
  height: 32px;
  padding-left: 6px;
}

.small-text {
  font-size: 0.8rem;
  color: var(--ion-color-medium);
}
.small-text a {
  text-decoration: underline;
  cursor: pointer;
  color: var(--ion-color-medium);
}`, "",{"version":3,"sources":["webpack://./src/app/shared-components/run-ocr-popup/run-ocr-popup.component.scss"],"names":[],"mappings":"AAAA;EACE,kCAAA;EACA,yBAAA;EACA,aAAA;EACA,wBAAA;AACF;;AAEA;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gDAAA;AACF;AAAE;EACE,aAAA;EACA,mBAAA;EACA,4BAAA;AAEJ;AADI;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAGN;;AAEA;EACE,kBAAA;EACA,oCAAA;EACA,qBAAA;EACA,iBAAA;EACA,iBAAA;AACF;;AAEA;EACE,YAAA;EACA,oCAAA;AACF;AAAE;EACE,kCAAA;EACA,mBAAA;AAEJ;AAAE;EACE,oCAAA;EACA,kBAAA;EACA,wBAAA;AAEJ;AAAE;EACE,YAAA;AAEJ;;AAEA;EACE,wCAAA;EACA,eAAA;AACF;;AAEA;EACE,8CAAA;EACA,gBAAA;EACA,aAAA;AACF;;AAEA;EACE,kBAAA;EACA,qBAAA;AACF;;AAEA;EACE,oCAAA;EACA,kBAAA;AACF;;AAEA;EACE,gBAAA;EACA,mDAAA;EACA,mDAAA;EACA,iDAAA;EACA,wCAAA;AACF;;AAEA;EACE,aAAA;EACA,qBAAA;EACA,yBAAA;AACF;AAAE;EACE,gBAAA;EACA,YAAA;EACA,iBAAA;AAEJ;;AAEA;EACE,iBAAA;EACA,8BAAA;AACF;AAAE;EACE,0BAAA;EACA,eAAA;EACA,8BAAA;AAEJ","sourcesContent":[".content-wrapper {\n  background: var(--ion-color-light);\n  padding: 10px 6px 6px 6px;\n  display: flex;\n  flex-flow: column nowrap;\n}\n\n.window-header {\n  display: flex;\n  flex-flow: row nowrap;\n  justify-content: space-between;\n  align-items: center;\n  padding-left: 10px;\n  padding-bottom: 4px;\n  margin-bottom: 16px;\n  border-bottom: 1px solid var(--ion-color-medium);\n  .window-title {\n    display: flex;\n    align-items: center;\n    color: var(--ion-color-dark);\n    ion-label {\n      padding-left: 6px;\n      font-size: 16px;\n      font-weight: 500;\n      cursor: default;\n    }\n  }\n}\n\n.page-detail {\n  font-style: italic;\n  color: var(--ion-color-primary-tint);\n  white-space: pre-line;\n  font-size: 0.9rem;\n  padding-left: 6px;\n}\n\n.log-content {\n  height: 70px;\n  --background: var(--ion-color-light);\n  ion-list {\n    background: var(--ion-color-light);\n    padding-bottom: 0px;\n  }\n  ion-item {\n    --background: var(--ion-color-light);\n    --min-height: 28px;\n    --inner-padding-end: 0px;\n  }\n  .log-date {\n    width: 150px;\n  }\n}\n\n.ocr-params-header {\n  background: var(--ion-color-light-shade);\n  cursor: pointer;\n}\n\n.ocr-params-body {\n  border: 1px solid var(--ion-color-light-shade);\n  overflow: hidden;\n  height: 100px;\n}\n\n.popover {\n  --padding-top: 6px;\n  --padding-bottom: 6px;\n}\n\n.popover-description {\n  color: var(--ion-color-primary-tint);\n  font-style: italic;\n}\n\nion-select {\n  min-height: 42px;\n  --highlight-color-focused: var(--ion-color-primary);\n  --highlight-color-invalid: var(--ion-color-primary);\n  --highlight-color-valid: var(--ion-color-primary);\n  --ripple-color: var(--ion-color-primary);\n}\n\n.buttons {\n  display: flex;\n  flex-flow: row nowrap;\n  justify-content: flex-end;\n  ion-button {\n    min-height: 32px;\n    height: 32px;\n    padding-left: 6px;\n  }\n}\n\n.small-text {\n  font-size: 0.8rem;\n  color: var(--ion-color-medium);\n  a {\n    text-decoration: underline;\n    cursor: pointer;\n    color: var(--ion-color-medium);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
